import { object, string, number } from 'yup'

export default object().shape({
  category: string().required(),
  comments: string().required(),
  max_adults: number().required()
})
